
export default class TransmitFileTypeConstants {
  constructor() {
  }
}
export const CODE_NAME = 'TransmitFileType'
export const BGD_TYPE = 'CUSTOMS DECLARTION'
export const TD_TYPE = 'MBL'
export const HBL_TYPE = 'HBL'
export const HXD_TYPE = 'VERIFICATION SHEET'
export const CODE = 'FileType'

